import React from 'react';
import { Navigate } from 'react-router-dom';
import { FeatureFlag, useFeatureFlags } from '../contexts/FeatureFlagsContext';

type Props = {
  flag: FeatureFlag;
  children: React.ReactNode;
  /** Destination si flag off (défaut : accueil). */
  fallbackTo?: string;
};

/**
 * Masque une route / sous-arbre si le flag est désactivé.
 * Absent/true → enfants rendus (0 régression).
 */
export const FeatureFlagGate: React.FC<Props> = ({
  flag,
  children,
  fallbackTo = '/',
}) => {
  const { isFeatureEnabled } = useFeatureFlags();
  if (!isFeatureEnabled(flag)) {
    return <Navigate to={fallbackTo} replace />;
  }
  return <>{children}</>;
};

export default FeatureFlagGate;
